import { useEffect, useState } from 'react';
import clsx from 'clsx';

interface ISegmentedControlProps {
  options: {
    label: string;
    value: string | number | null;
  }[];

  onValueChange?: (value: string | number | null) => void;

  defaultValue?: string | null;
  forceValue?: string | null;

  disabled?: boolean;
}

export default function SegmentedControl(props: ISegmentedControlProps) {
  const { options, defaultValue = options[0]?.value, forceValue, onValueChange, disabled = false } = props;

  const [value, setValue] = useState<string | number | null>(forceValue || defaultValue);

  const handleValueChange = (value: string | number | null) => {
    setValue(value);
    onValueChange?.(value);
  };

  useEffect(() => {
    if (typeof forceValue !== 'undefined') {
      setValue(forceValue);
    }
  }, [forceValue]);

  return (
    <div className="segmented-control">
      {options.map((option) => (
        <button
          type="button"
          disabled={disabled}
          key={option.value}
          className={clsx('segmented-control-item', { active: value === option.value })}
          onClick={() => handleValueChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
